


export const containerStyles = {
    borderColor: 'common.borderGrey',
    direction: "column" as 'column',
    bg: 'brand.secondary',
    color: "text.grey",
    padding: { base: '16px 8px', sm: '16px' },
    justifyContent: 'center' as 'center',
    width: '100%',
}

// export 

export const headingStyle = {
    textStyle: "h2",
    textAlign: "left" as 'left',
    borderBottom: 'solid 1px',
    paddingBottom: '16px'
}

export const fieldFlexStyle = {
    direction: { base: 'column' as 'column', sm: 'row' as 'row' },
    gap: "24px"
}
export const doubleFieldWidth = { width: { sm: '100%', md: '66.66%' } }
export const singleFieldWidth = { width: { base: '100%', sm: '48%', md: '32.5%' } }
export const commonInputStyleProps = {
    borderRadius: '4px',
    border: '1px solid',
    borderColor: 'common.borderGrey',
    color: 'text.grey',
    w: { base: '100%', sm: '453px' },
    bg: 'common.white'
}
export const selectTagProps = {
    required: true,
    h: '36px',
    pl: '32px',
    borderRadius: '0 4px 4px 0',
    borderColor: 'common.borderGrey',
    borderLeft: 'none',
    _focus: {
        focusBorderColor: 'common.borderGrey',
        boxShadow: 'none',
    }
}
export const militaryTypes = [
    {
        description: `NA`,
        value: 0
    },
    {
        description: `Active`,
        value: 1
    },
    {
        description: `Reserve`,
        value: 2
    },
    {
        description: `Veteran`,
        value: 3
    },
    {
        description: `Retired`,
        value: 4
    },
    {
        description: `Deployed`,
        value: 5
    },
]

export const militaryBranches = [
    {
        description: `NA`,
        value: 0
    },
    {
        description: `Army`,
        value: 1
    },
    {
        description: `Navy`,
        value: 2
    },
    {
        description: `AirForce`,
        value: 3
    },
    {
        description: `Marines`,
        value: 4
    },
    {
        description: `CoastGuard`,
        value: 5
    },
]

export const americanStates = [
    {
        description: 'Alaska',
        id: 'AK'
    },
    {
        description: 'Alabama',
        id: 'AL'
    },
    {
        description: 'Arkansas',
        id: 'AR'
    },
    {
        description: 'Arizona',
        id: 'AZ'
    },
    {
        description: 'Alberta',
        id: 'AB'
    },
    {
        description: 'American Samoa',
        id: 'AS'
    },
    {
        description: 'California',
        id: 'CA'
    },
    {
        description: 'Colorado',
        id: 'CO'
    },
    {
        description: 'Connecticut',
        id: 'CT'
    },
    {
        description: 'Delaware',
        id: 'DE'
    },
    {
        description: 'District Of Columbia',
        id: 'DC'
    },
    {
        description: 'Federated States Of Micronesia',
        id: 'FM'
    },
    {
        description: 'Florida',
        id: 'FL'
    },
    {
        description: 'Georgia',
        id: 'GA'
    },
    {
        description: 'Guam',
        id: 'GU'
    },
    {
        description: 'Hawaii',
        id: 'HI'
    },
    {
        description: 'Idaho',
        id: 'ID'
    },
    {
        description: 'Illinois',
        id: 'IL'
    },
    {
        description: 'Indiana',
        id: 'IN'
    },
    {
        description: 'Iowa',
        id: 'IA'
    },
    {
        description: 'Kansas',
        id: 'KS'
    },
    {
        description: 'Kentucky',
        id: 'KY'
    },
    {
        description: 'Louisiana',
        id: 'LA'
    },
    {
        description: 'Maine',
        id: 'ME'
    },
    {
        description: 'Marshall Islands',
        id: 'MH'
    },
    {
        description: 'Maryland',
        id: 'MD'
    },
    {
        description: 'Massachusetts',
        id: 'MA'
    },
    {
        description: 'Michigan',
        id: 'MI'
    },
    {
        description: 'Minnesota',
        id: 'MN'
    },
    {
        description: 'Mississippi',
        id: 'MS'
    },
    {
        description: 'Missouri',
        id: 'MO'
    },
    {
        description: 'Montana',
        id: 'MT'
    },
    {
        description: 'Nebraska',
        id: 'NE'
    },
    {
        description: 'Nevada',
        id: 'NV'
    },
    {
        description: 'New Hampshire',
        id: 'NH'
    },
    {
        description: 'New Jersey',
        id: 'NJ'
    },
    {
        description: 'New Mexico',
        id: 'NM'
    },
    {
        description: 'New York',
        id: 'NY'
    },
    {
        description: 'North Carolina',
        id: 'NC'
    },
    {
        description: 'North Dakota',
        id: 'ND'
    },
    {
        description: 'Northern Mariana Islands',
        id: 'MP'
    },
    {
        description: 'Ohio',
        id: 'OH'
    },
    {
        description: 'Oklahoma',
        id: 'OK'
    },
    {
        description: 'Oregon',
        id: 'OR'
    },
    {
        description: 'Palau',
        id: 'PW'
    },
    {
        description: 'Pennsylvania',
        id: 'PA'
    },
    {
        description: 'Puerto Rico',
        id: 'PR'
    },
    {
        description: 'Rhode Island',
        id: 'RI'
    },
    {
        description: 'South Carolina',
        id: 'SC'
    },
    {
        description: 'South Dakota',
        id: 'SD'
    },
    {
        description: 'Tennessee',
        id: 'TN'
    },
    {
        description: 'Texas',
        id: 'TX'
    },
    {
        description: 'Utah',
        id: 'UT'
    },
    {
        description: 'Vermont',
        id: 'VT'
    },
    {
        description: 'Virgin Islands',
        id: 'VI'
    },
    {
        description: 'Virginia',
        id: 'VA'
    },
    {
        description: 'Washington',
        id: 'WA'
    },
    {
        description: 'West Virginia',
        id: 'WV'
    },
    {
        description: 'Wisconsin',
        id: 'WI'
    },
    {
        description: 'Wyoming',
        id: 'WY'
    },
];

export const canadianProvince = [
    {
        description: 'Alberta',
        id: 'AB'
    },
    {
        description: 'British Columbia',
        id: 'BC'
    },
    {
        description: 'Manitoba',
        id: 'MB'
    },
    {
        description: 'New Brunswick',
        id: 'NB'
    },
    {
        description: 'Newfoundland and Labrador',
        id: 'NL'
    },
    {
        description: 'Northwest Territories',
        id: 'NT'
    },
    {
        description: 'Nova Scotia',
        id: 'NS'
    },
    {
        description: 'Nunavut',
        id: 'NU'
    },
    {
        description: 'Ontario',
        id: 'ON'
    },
    {
        description: 'Prince Edward Island',
        id: 'PE'
    },
    {
        description: 'Quebec',
        id: 'QC'
    },
    {
        description: 'Saskatchewan',
        id: 'SK'
    },
    {
        description: 'Yukon',
        id: 'YT'
    },
];

